// Platform detection — v3.7
//
// Single-purpose: identify iOS/iPadOS devices reliably and stamp an
// `is-ios` class on the document root so CSS can branch without JS at
// render time. The class is used exclusively by the Experiences card
// flip system to swap the 3D rotateY animation for an opacity
// cross-fade on iOS — see /app/frontend/src/index.css ("iOS-only flip
// path"). Android, desktop (including macOS desktop Safari), and all
// other platforms are intentionally NOT marked and keep the existing
// 3D flip behavior byte-for-byte.
//
// Detection strategy:
//   1. iPhone / iPod          → UA contains 'iPhone' or 'iPod'
//   2. Legacy iPad             → UA contains 'iPad'
//   3. iPadOS 13+ "Request Desktop Site" mode (default for iPad)
//                              → UA contains 'Mac' AND
//                                navigator.maxTouchPoints > 1
//                                (macOS desktop has maxTouchPoints === 0
//                                 because Macs don't expose a touchscreen
//                                 API; the Mac trackpad emits Pointer
//                                 events, not Touch events).
//
// Deliberately NOT using viewport width (iPad landscape exceeds 1024px;
// iPhone landscape exceeds 900px). Deliberately NOT using a feature
// query like @supports (-webkit-touch-callout: none), because that
// matches macOS desktop Safari too.

export function isIOSDevice() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    const ua = navigator.userAgent || '';
    if (/iPhone|iPod/.test(ua)) return true;
    if (/iPad/.test(ua)) return true;
    // iPadOS 13+ identifies as MacIntel by default. Disambiguate from
    // real macOS by the presence of a touchscreen.
    const mtp = typeof navigator.maxTouchPoints === 'number' ? navigator.maxTouchPoints : 0;
    if (/Mac/.test(ua) && mtp > 1) return true;
    return false;
}

export function applyIOSClass() {
    if (typeof document === 'undefined') return;
    const html = document.documentElement;
    if (!html) return;
    if (isIOSDevice()) html.classList.add('is-ios');
}

// Run once on module load — this file is imported for side-effect at
// the top of src/index.js, which is evaluated synchronously before
// React mounts. No useEffect timing concerns and no FOUC.
applyIOSClass();
